import React, {
	memo,
	RefObject,
	useCallback,
	useRef,
	useState,
	ChangeEvent,
	useEffect,
} from 'react'
import { makeStyles } from '@material-ui/styles'
import { useTranslation } from 'react-i18next'
import cuid from 'cuid'
import * as _ from 'lodash'
import Button from '@material-ui/core/Button'
import { FormControl, Grid, InputLabel } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import Fab from '@material-ui/core/Fab'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined'
import Input from '@material-ui/core/Input'
import classNames from 'classnames'
import Chip from '@material-ui/core/Chip'
import FroalaEditor from 'react-froala-wysiwyg'
import axios from 'axios'
import { Translation } from 'react-i18next'

import styles from '../styles'
import { EUserOnboardingActionTypes, EEntity } from 'models'
import { UserOnboardingStateValue } from '../reducer'
import { StoreValue } from 'store'
import { FROALA_KEY, buildUserAvatar, SIGN_REQUEST_URIS } from 'utils'
import { UploadCrop } from 'components'

const useStyles = makeStyles(styles)

const Step1View: React.FunctionComponent<any> = props => {
	const {
		id,
		firstName,
		lastName,
		aboutMe,
		imageCover,
		imageAvatar,
		error,
		handleNext,
		userOnBoardDispatch,
		storeUserId,
		storeUser,
		userStoreFirstName, // first name and last name from user store
		userStoreLastName,
	} = props
	const classes = useStyles()
	const { t } = useTranslation()

	const uploadInputImgCover: RefObject<HTMLInputElement> = useRef(null)
	const [stageImgAvatar, setStageImgAvatar] = useState(imageCover ? 4 : 0)
	const [stageImgCover, setStageImgCover] = useState(imageAvatar ? 4 : 0)
	const [showUploadCrop, setShowUploadCrop] = useState(false)
	const [percent, setPercent] = useState(0)
	// const [imgProfileFileId, setImgProfileFileId] = useState(
	// 	(imageCover && imageCover.id) || '',
	// )
	// const [imgAvatarFileId, setImgAvatarFileId] = useState(
	// 	(imageAvatar && imageAvatar.id) || '',
	// )
	const config = {
		events: {
			'paste.afterCleanup': function (html: string) {
				let div = document.createElement('div')
				div.innerHTML = html
				return div.innerText
			},
		},
		videoUpload: false,
		imageUploadURL: false,
		imageUploadToS3: null,
		placeholderText: t('About me'),
		charCounterCount: true,
		toolbarInline: false,
		toolbarButtons: [
			'bold',
			'italic',
			'underline',
			'strikeThrough',
			'alignLeft',
			'alignCenter',
			'formatOLSimple',
			'alignRight',
			'alignJustify',
			'formatOL',
			'formatUL',
		],
		key: FROALA_KEY,
		attribution: false,
		pastePlain: true,
	}
	const profileCoverExtension = '-profile-cover-original'
	const toggleShowUploadCrop = useCallback(() => {
		setShowUploadCrop(show => !show)
	}, [])
	const handleFirstNameChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			userOnBoardDispatch({
				type: EUserOnboardingActionTypes.setFirstName,
				firstName: event.target.value,
			})
		},
		[userOnBoardDispatch],
	)
	const handleLastNameChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			userOnBoardDispatch({
				type: EUserOnboardingActionTypes.setLastName,
				lastName: event.target.value,
			})
		},
		[userOnBoardDispatch],
	)
	const handleAboutMeChange = useCallback(
		(value: string) => {
			userOnBoardDispatch({
				type: EUserOnboardingActionTypes.setAboutMe,
				aboutMe: value,
			})
		},
		[userOnBoardDispatch],
	)
	const handleUserProfileUpload = useCallback(
		(logoPath: string) => {
			setStageImgAvatar(4)
			userOnBoardDispatch({
				type: EUserOnboardingActionTypes.setImageCover,
				imageCover: logoPath,
			})
		},
		[userOnBoardDispatch],
	)
	const handleDeleteProfileAvatar = useCallback(() => {
		setStageImgAvatar(1)
		userOnBoardDispatch({
			type: EUserOnboardingActionTypes.setImageCover,
			imageCover: '',
		})
	}, [userOnBoardDispatch])

	const handleDeleteProfileCover = useCallback(() => {
		setStageImgCover(1)
		userOnBoardDispatch({
			type: EUserOnboardingActionTypes.setImageAvatar,
			imageAvatar: '',
		})
	}, [userOnBoardDispatch])

	const triggerImgProfileAvatarSelect = useCallback(() => {
		toggleShowUploadCrop()
		// if (uploadInputImgProfileAvatar && uploadInputImgProfileAvatar.current)
		// uploadInputImgProfileAvatar.current.click()
	}, [toggleShowUploadCrop])
	const triggerImgCoverSelect = useCallback(() => {
		if (uploadInputImgCover && uploadInputImgCover.current)
			uploadInputImgCover.current.click()
	}, [uploadInputImgCover])

	const handleImgProfileCoverSelect = useCallback(
		(ev: ChangeEvent<HTMLInputElement>) => {
			setStageImgCover(1)
			const source: any =
				uploadInputImgCover &&
				uploadInputImgCover.current &&
				uploadInputImgCover.current.files &&
				uploadInputImgCover.current.files[0]
			const blob = source.slice(0, source.size, source.type)
			const imgProfileCoverFileId = cuid()
			// setImgProfileFileId(imgProfileCoverFileId)
			const file = new File(
				[blob],
				`${imgProfileCoverFileId}${profileCoverExtension}`,
				{
					type: source.type,
				},
			)
			const params = {
				userId: storeUserId,
				fileName: file && file.name,
				contentType: file && file.type,
				environment: process.env.REACT_APP_ENVIRONMENT,
				id,
				type: 'user',
			}
			axios({
				method: 'post',
				// @ts-ignore
				url: SIGN_REQUEST_URIS[process.env.REACT_APP_ENVIRONMENT],
				data: params,
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})
				.then(({ data: { signedUrl } }: any) => {
					setStageImgCover(3)
					var options = {
						headers: {
							'Content-Type': file && file.type,
						},
						onUploadProgress: (progressEvent: any) => {
							let newPercent: any =
								(progressEvent.loaded / progressEvent.total) *
								100
							if (newPercent > 100) newPercent = 100
							setPercent(newPercent.toFixed(0))
						},
					}
					axios
						.put(signedUrl, file, options)
						.then(() => {
							userOnBoardDispatch({
								type: EUserOnboardingActionTypes.setImageAvatar,
								imageAvatar:
									imgProfileCoverFileId +
									profileCoverExtension,
							})
							setStageImgCover(4)
						})
						.catch(error => {
							console.error(error)
						})
				})
				.catch(error => {
					setStageImgCover(2)
					console.error(error)
				})
		},
		[id, storeUserId, userOnBoardDispatch],
	)
	const isNotValidStep = useCallback(() => {
		return _.isEmpty(firstName) || _.isEmpty(lastName) || _.isEmpty(aboutMe)
	}, [firstName, lastName, aboutMe])

	const goToNextStep = useCallback(
		_error => {
			if (isNotValidStep()) {
				userOnBoardDispatch({
					type: EUserOnboardingActionTypes.setError,
					errors: {
						firstName: _.isEmpty(firstName),
						lastName: _.isEmpty(lastName),
						aboutMe: _.isEmpty(aboutMe),
					},
				})
				return
			}
			handleNext()
		},
		[
			userOnBoardDispatch,
			isNotValidStep,
			handleNext,
			aboutMe,
			lastName,
			firstName,
		],
	)

	let uploadTextImgCover: any = ''
	switch (stageImgAvatar) {
		case 1:
			uploadTextImgCover = t('Preparing ...')
			break
		case 2:
			uploadTextImgCover = t('Something went wrong ... try again')
			break
		case 3:
			uploadTextImgCover = t('Uploading ... ') + percent + '%'
			break

		default:
			uploadTextImgCover = (
				<>
					<AddIcon />
					<div>{t('Add cover photo')}</div>
				</>
			)
	}
	let uploadTextImgAvatar: any = ''
	switch (stageImgCover) {
		case 1:
			uploadTextImgAvatar = t('Preparing ...')
			break
		case 2:
			uploadTextImgAvatar = t('Something went wrong ... try again')
			break
		case 3:
			uploadTextImgAvatar = t('Uploading ... ') + percent + '%'
			break

		default:
			uploadTextImgAvatar = (
				<>
					<AddIcon />
					<div>{t('Add avatar image')}</div>
				</>
			)
	}

	const updatePercent = useCallback(value => {
		const parsedValue = parseInt(value, 10)
		setPercent(parsedValue)
	}, [])

	useEffect(() => {
		if (userStoreFirstName) {
			userOnBoardDispatch({
				type: EUserOnboardingActionTypes.setFirstName,
				firstName: userStoreFirstName,
			})
		}
		if (userStoreLastName) {
			userOnBoardDispatch({
				type: EUserOnboardingActionTypes.setLastName,
				lastName: userStoreLastName ? userStoreLastName : '',
			})
		}
	}, [userOnBoardDispatch, userStoreFirstName, userStoreLastName])

	return (
		<div>
			<Grid container direction={'row'} spacing={1}>
				<Grid item xs={12} sm={6}>
					<div className={classes.imgWrap}>
						{stageImgAvatar !== 4 ? (
							<>
								<Button
									color="primary"
									className={classes.imgUploadBtn}
									onClick={triggerImgProfileAvatarSelect}
								>
									{uploadTextImgAvatar}
								</Button>
							</>
						) : (
							<>
								<Chip
									onClick={handleDeleteProfileAvatar}
									style={{ background: '#fff' }}
									icon={<DeleteOutlinedIcon />}
									variant="outlined"
									color={'secondary'}
									clickable={true}
									classes={{
										label: classes.deleteIconLabel,
										root: classes.deleteRootElement,
									}}
								/>
								<img
									className={classes.userAvatarImg}
									src={buildUserAvatar(
										storeUserId,
										imageCover,
									)}
									alt=""
								/>
							</>
						)}
					</div>
				</Grid>
				<Grid item xs={12} sm={6}>
					<div className={`${classes.imgWrap} ${classes.avatarImg}`}>
						<input
							onChange={handleImgProfileCoverSelect}
							ref={uploadInputImgCover}
							type="file"
							style={{ display: 'none' }}
						/>

						{stageImgCover !== 4 ? (
							<>
								<input
									onChange={handleImgProfileCoverSelect}
									ref={uploadInputImgCover}
									type="file"
									style={{ display: 'none' }}
								/>
								<Button
									color="primary"
									className={classes.imgUploadBtn}
									onClick={triggerImgCoverSelect}
								>
									{uploadTextImgCover}
								</Button>
							</>
						) : (
							<>
								<Chip
									onClick={handleDeleteProfileCover}
									style={{ background: '#fff' }}
									icon={<DeleteOutlinedIcon />}
									variant="outlined"
									color={'secondary'}
									clickable={true}
									classes={{
										label: classes.deleteIconLabel,
										root: classes.deleteRootElement,
									}}
								/>
								<img
									style={{
										width: '100%',
										maxHeight: 300,
										alignSelf: 'center',
									}}
									src={buildUserAvatar(
										storeUserId,
										imageAvatar,
									)}
									alt=""
								/>
							</>
						)}
					</div>
				</Grid>
			</Grid>
			<Grid container spacing={0}>
				<Grid item xs={12}>
					<FormControl className={classes.formControl}>
						<InputLabel htmlFor="firstName">
							<Translation key="firstNameRequired">
								{t => (
									<div
										className={classNames(
											classes.labelField,
											{
												[classes.labelFieldError]:
													error.firstName,
											},
										)}
									>
										{t('First Name')}
										<span
											className={classNames(
												classes.requiredField,
												{
													[classes.labelFieldError]:
														error.firstName,
												},
											)}
										>
											{`(${t('Required')})`}
										</span>
									</div>
								)}
							</Translation>
						</InputLabel>
						<Input
							id="firstName"
							// error={error.firstName}
							className={classes.textField}
							value={firstName}
							onChange={handleFirstNameChange}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={12}>
					<FormControl className={classes.formControl}>
						<InputLabel htmlFor="lastName">
							<Translation key="lastNameRequired">
								{t => (
									<div
										className={classNames(
											classes.labelField,
											{
												[classes.labelFieldError]:
													error.lastName,
											},
										)}
									>
										{t('Last Name')}
										<span
											className={classNames(
												classes.requiredField,
												{
													[classes.labelFieldError]:
														error.lastName,
												},
											)}
										>
											{`(${t('Required')})`}
										</span>
									</div>
								)}
							</Translation>
						</InputLabel>
						<Input
							id="lastName"
							className={classNames(classes.textField, {
								[classes.labelFieldError]: error.lastName,
							})}
							// error={error.lastName}
							value={lastName}
							onChange={handleLastNameChange}
						/>
					</FormControl>
				</Grid>
				<Grid item xs={12}>
					<div className={classes.formControl}>
						<div
							className={classNames(
								classes.labelField,
								classes.mb10,
								{
									[classes.labelFieldError]: error.aboutMe,
								},
							)}
						>
							{t('About me ')}
							<span
								className={classNames(classes.requiredField, {
									[classes.labelFieldError]: error.aboutMe,
								})}
							>
								{`(${t('Required')})`}
							</span>
						</div>
						<FroalaEditor
							tag="textarea"
							config={config}
							model={aboutMe}
							onModelChange={handleAboutMeChange}
						/>
					</div>
				</Grid>
				<Grid item xs={12}>
					<div className={classes.btnsContainer}>
						<Fab
							onClick={() => goToNextStep(error)}
							className={classes.nextBtn}
							variant="extended"
							size="medium"
							color="primary"
							aria-label="Add"
						>
							{t('Next') || ''}
						</Fab>
					</div>
				</Grid>
			</Grid>
			<UploadCrop
				open={showUploadCrop}
				handleClose={toggleShowUploadCrop}
				updatePercent={updatePercent}
				user={storeUser}
				type={EEntity.person}
				onAdd={(imageCover: string) => {
					handleUserProfileUpload(imageCover)
				}}
			/>
		</div>
	)
}

const Step1WithStoreValue = (props: any) => (
	<StoreValue
		keys={[
			'user|storeUser',
			'user.id|storeUserId',
			'user.profile.firstName|userStoreFirstName',
			'user.profile.lastName|userStoreLastName',
		]}
	>
		<Step1View {...props} />
	</StoreValue>
)

const Step1 = memo((props: any) => (
	<UserOnboardingStateValue
		keys={[
			'id',
			'userOnBoardDispatch',
			'firstName',
			'lastName',
			'aboutMe',
			'imageCover',
			'imageAvatar',
			'error',
		]}
	>
		<Step1WithStoreValue {...props} />
	</UserOnboardingStateValue>
))

export default Step1
